'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _incompletedocumentation = require('./incompletedocumentation.component');

var _incompletedocumentation2 = _interopRequireDefault(_incompletedocumentation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var incompletedocumentationModule = _angular2.default.module('incompletedocumentation', [_angularUiRouter2.default]).component('incompletedocumentation', _incompletedocumentation2.default);

exports.default = incompletedocumentationModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/incompletedocumentation/incompletedocumentation.js